export default __webpack_public_path__ + "static/buckle-collar-1-17b200c3b9271469f591f319cc62fdf8.jpg";